// extracted by mini-css-extract-plugin
export default {"errorBox":"ErrorMsg_errorBox__ooob2"};